import React from "react";
import { Droppable, Draggable } from "react-beautiful-dnd";
// import {withRouter} from 'react-router-dom';
import { ItemContainer } from "../styled";
import { Wrapper, DropZone, AddNew, StageFooter } from "./styled";
import AddIcon from "@material-ui/icons/Add";
import { AddDealModal } from "../common/dealModal/index";
import { GreenGradientButton } from "../../../components/button";
import { OverlayTrigger, Popover } from "react-bootstrap";
import "./styles.scss";
import moment from "moment";
import { connect } from "react-redux";
import { MarkAsDoneActivity } from "../../../components/activity/mark_as_done";
import { ListGroup } from "react-bootstrap";
import { ScheduleOnlyADateDisplay } from "../../../components/custom-table-data-display/due-date-display";
import InlineStyled from "../../../components/inline-styled/inline-styled";

class DraggableContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openComposer: false,
      markasDoneActivity: false,
      selectedLostReason: "",
      selectedLostReasonId: "",
      marksAsLostUi: false,
      selectedActivityId: "",
    };
  }

  onSendEmailClick = () => {
    this.props.openComposer(true);
  };

  openScheduleActivityClick = (itemToShow) => {
    this.props.openScheduleActivity(true, itemToShow._id, itemToShow.title);
  };

  openSidePanelClick = (item) => {
    this.props.history.push(`/deal/pipeline/${this.props.selectedPipelineId}/${item._id}`);
  };

  onClickMarkAsDoneActivity = (e, activity) => {
    if (!this.props.lostReasonStatus) {
      let obj = {
        data: {
          id: activity._id,
          reasonId: "",
          comment: "",
          pipelineId: this.props.selectedPipelineId,
        },
      };
      this.props.callActivityMADoneApi(obj);
    } else {
      this.setState({ markasDoneActivity: e.target.checked, marksAsLostUi: true, selectedActivityId: activity._id });
    }
  };

  onLostReasonChange = (reason) => {
    this.setState({
      selectedLostReason: reason.reason,
      selectedLostReasonId: reason._id,
    });
  };

  onLostReasonCommentsChange = (e) => {
    this.setState({
      lossDealComment: e.target.value,
    });
  };

  onLossDealSave = (payload) => {
    this.props.callActivityMADoneApi(payload.data);
  };

  getColor = (itemtoShow) => {
    if (itemtoShow.activities.length === 0) {
      return "#008FBD";
    } else {
      const status = itemtoShow.activities[0].activityStatus;

      if (status === "overdue") return "#e34e6c";
      else if (status === "upcoming") return "#73ce89";
      else if (status === "todo") return "#f6c61b";
    }
    return "#f6c61b";
  };

  render() {
    const { item } = this.props;
    return item && item.deals && item.deals.length > 0
      ? item.deals.map((itemtoShow, index) => (
        <Draggable key={itemtoShow._id} draggableId={itemtoShow._id} index={index}>
          {(dragProvided, snapshot) => (
            <ItemContainer
              className="card"
              onClick={() => this.openSidePanelClick(itemtoShow)}
              ref={dragProvided.innerRef}
              {...dragProvided.draggableProps}
              {...dragProvided.dragHandleProps}
              status={itemtoShow.activities.length > 0 ? itemtoShow.activities[0].activityStatus : ""}
              dealStatus={itemtoShow.status}
            >
              <div>
                <div className="p-6">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="webkit-box-1-line fw-500 font-size-15px w-250px-mx text-008fbd">
                      {itemtoShow.title ? itemtoShow.title : null}
                      {itemtoShow.status === "won" && <span className="badge badge-light-success fs-8 ml-2">Won</span>}
                      {itemtoShow.status === "lost" && <span className="badge badge-light-danger fs-8 ml-2">Lost</span>}
                      {itemtoShow.status === "archived" && <span className="badge badge-light-warning fs-8 ml-2">Archived</span>}
                    </div>
                    <div>
                      <OverlayTrigger
                        rootClose={true}
                        placement="bottom"
                        trigger="click"
                        className="z-index-0"
                        onExit={() => this.setState({ markasDoneActivity: false, marksAsLostUi: false, selectedActivityId: "" })}
                        overlay={
                          <Popover id="popover-basic" onClick={(e) => e.stopPropagation()} className="w-430px w-350px-mx">
                            <Popover.Title>
                              <div className="fw-500 font-size-15px text-26292c">Planned Activities</div>
                            </Popover.Title>
                            <Popover.Content className={this.state.marksAsLostUi ? "p-2" : "p-4"}>
                              {this.state.marksAsLostUi ? (
                                <>
                                  <MarkAsDoneActivity
                                    activityId={this.state.selectedActivityId}
                                    showNextSchedule={false}
                                    handleCancel={() => {
                                      this.setState({ marksAsLostUi: false, markasDoneActivity: false });
                                    }}
                                    handleSave={this.onLossDealSave}
                                  />
                                </>
                              ) : (
                                <>
                                  <ListGroup className="mb-8 ">
                                    {itemtoShow.activities.length > 0 &&
                                      itemtoShow.activities.map((activity, index) => (
                                        <ListGroup.Item key={index} className="d-flex align-items-start justify-content-between">
                                          <div className="form-check m-0 p-0" title="Mark as done w-25px">
                                            <input
                                              className="form-check-input m-0 w-20px h-20px"
                                              type="radio"
                                              value=""
                                              id="flexCheckChecked"
                                              checked={this.state.markasDoneActivity}
                                              onChange={(e) => this.onClickMarkAsDoneActivity(e, activity)}
                                            />
                                          </div>
                                          <div className="d-flex flex-column gap-3 w-100-40px">
                                            <div className="gap-2 font-size-14px text-26292c">
                                              <i className={activity.activitySymbol} />
                                              <span className="line-height-xl text-0893bf"> {activity.activityName}</span>
                                            </div>
                                            <div className="d-flex flex-stack align-items-center">
                                              <span
                                                className={`badge font-size-13px ${activity.activityStatus === "overdue" ? "badge-light-danger" : activity.activityStatus === "upcoming" ? "badge-light-success" : "badge-light-warning"
                                                  }`}
                                              >
                                                {activity.activityStatus}
                                              </span>
                                              <span className="font-size-13px text-747678">
                                                <ScheduleOnlyADateDisplay data={activity.value} />{" "}
                                              </span>
                                            </div>
                                          </div>
                                        </ListGroup.Item>
                                      ))}
                                  </ListGroup>
                                  <div className="d-flex flex-row justify-content-center m-0 gap-0">
                                    <GreenGradientButton
                                      onClick={(e) => {
                                        this.openScheduleActivityClick(itemtoShow);
                                      }}
                                      size="sm"
                                    >
                                      {" "}
                                      + Schedule an activity
                                    </GreenGradientButton>
                                  </div>
                                </>
                              )}
                            </Popover.Content>
                          </Popover>
                        }
                      >
                        <span
                          className="cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M4.04692 4.39073H6.04697V3.39078H14.0467V4.39073H16.0467V3.39078H18.0468V6.39078H2.04652V3.39078H4.04657L4.04692 4.39073ZM2.04686 8.39067V18.391H18.0471V8.39067H2.04686ZM6.04697 1.39081H14.0467V0.390869H16.0467V1.39081H18.0468C19.1514 1.39081 20.0467 2.28631 20.0467 3.39087V18.3909C20.0467 19.4954 19.1514 20.3908 18.0468 20.3908H2.04652C0.94196 20.3908 0.0466309 19.4954 0.0466309 18.3909V3.39087C0.0466309 2.28631 0.94196 1.39081 2.04652 1.39081H4.04657V0.390869H6.04663L6.04697 1.39081ZM6.04697 14.3907V12.3908H9.04697V9.39078H11.0469V12.3908H14.0469V14.3907H11.0469V17.3907H9.04697V14.3907H6.04697Z"
                              fill={this.getColor(itemtoShow)}
                            />
                          </svg>
                        </span>
                      </OverlayTrigger>
                    </div>
                  </div>
                  <div className="d-flex gap-3 align-items-center mt-2">
                    {itemtoShow.people && itemtoShow.people.name && (
                      <InlineStyled className="custom-ellipsis font-size-13px text-747678" styles={{ customWidth: "48%" }}>
                        <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M6.99995 6.56252C7.51049 6.56252 8.00011 6.3597 8.36113 5.9987C8.72215 5.63768 8.92495 5.14808 8.92495 4.63752C8.92495 4.12696 8.72213 3.63736 8.36113 3.27634C8.00011 2.91532 7.51051 2.71252 6.99995 2.71252C6.48939 2.71252 5.99979 2.91534 5.63877 3.27634C5.27775 3.63736 5.07495 4.12696 5.07495 4.63752C5.07495 5.14808 5.27777 5.63768 5.63877 5.9987C5.99979 6.35972 6.48939 6.56252 6.99995 6.56252ZM6.99995 3.06252C7.41769 3.06252 7.81831 3.22846 8.11363 3.52384C8.40903 3.81916 8.57495 4.21978 8.57495 4.63752C8.57495 5.05526 8.40901 5.45588 8.11363 5.7512C7.81831 6.0466 7.41769 6.21252 6.99995 6.21252C6.58221 6.21252 6.18159 6.04659 5.88627 5.7512C5.59087 5.45588 5.42495 5.05526 5.42495 4.63752C5.42495 4.21978 5.59089 3.81916 5.88627 3.52384C6.18159 3.22844 6.58221 3.06252 6.99995 3.06252Z"
                            fill="#747678"
                          />
                          <path
                            d="M7.3499 6.73755H6.6499C5.5824 6.73755 4.5587 7.16161 3.8039 7.91645C3.04906 8.67129 2.625 9.69505 2.625 10.7624C2.625 10.9017 2.68031 11.0353 2.77875 11.1337C2.87719 11.2321 3.01079 11.2874 3.14999 11.2874H10.85C10.9892 11.2874 11.1228 11.2321 11.2212 11.1337C11.3197 11.0353 11.375 10.9016 11.375 10.7624C11.375 9.69495 10.9509 8.67125 10.1961 7.91645C9.44124 7.16161 8.41748 6.73755 7.35008 6.73755H7.3499ZM10.8499 10.9375H3.1499C3.05326 10.9375 2.9749 10.8592 2.9749 10.7625C2.9749 9.78787 3.36208 8.85309 4.0513 8.16395C4.74044 7.47473 5.6752 7.08755 6.6499 7.08755H7.3499C8.32458 7.08755 9.25936 7.47473 9.9485 8.16395C10.6377 8.85309 11.0249 9.78785 11.0249 10.7625C11.0249 10.809 11.0065 10.8535 10.9737 10.8863C10.9408 10.9191 10.8963 10.9375 10.8499 10.9375Z"
                            fill="#747678"
                          />
                        </svg>
                        <span> {itemtoShow.people.name}</span>
                      </InlineStyled>
                    )}
                    {itemtoShow.company && itemtoShow.company.name && (
                      <InlineStyled className="custom-ellipsis font-size-13px text-747678" styles={{ customWidth: "48%" }}>
                        <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M11.0321 10.8147H10.3601V4.76675C10.3669 4.66589 10.3041 4.57347 10.2077 4.54277L8.12012 3.85731V2.96129C8.12012 2.90191 8.09653 2.84496 8.0545 2.80293C8.01255 2.7609 7.95552 2.7373 7.89614 2.7373H3.86414C3.74047 2.7373 3.64016 2.83762 3.64016 2.96128V10.8147H2.96812C2.84445 10.8147 2.74414 10.915 2.74414 11.0387C2.74414 11.1624 2.84445 11.2627 2.96812 11.2627H11.0321C11.1558 11.2627 11.2561 11.1624 11.2561 11.0387C11.2561 10.915 11.1558 10.8147 11.0321 10.8147L11.0321 10.8147ZM9.91211 4.92795V10.8147H8.12007V4.32775L9.91211 4.92795ZM5.65611 10.8147V9.91881H6.10407V10.8148L5.65611 10.8147ZM6.32807 9.47077H5.43213C5.30838 9.47077 5.20807 9.57108 5.20807 9.69475V10.8147H4.08807V3.19875H7.67207L7.67215 10.8147H6.55215V9.68131C6.54496 9.56287 6.44676 9.47053 6.32809 9.47077H6.32807ZM5.64713 8.35077C5.64721 8.47108 5.55228 8.56999 5.43213 8.57475H4.98409C4.86042 8.57475 4.76011 8.47451 4.76011 8.35077C4.76011 8.2271 4.86042 8.12679 4.98409 8.12679H5.43213C5.55228 8.13163 5.64721 8.23046 5.64713 8.35077ZM6.80299 8.57475H6.32807C6.2044 8.57475 6.10409 8.47451 6.10409 8.35077C6.10409 8.2271 6.2044 8.12679 6.32807 8.12679H6.77611C6.89978 8.12679 7.00009 8.2271 7.00009 8.35077C7.00009 8.47452 6.89978 8.57475 6.77611 8.57475H6.80299ZM5.64713 7.00679C5.64721 7.1271 5.55228 7.22601 5.43213 7.23077H4.98409C4.86042 7.23077 4.76011 7.13054 4.76011 7.00679C4.76011 6.88304 4.86042 6.78281 4.98409 6.78281H5.43213C5.55228 6.78757 5.64721 6.88648 5.64713 7.00679ZM6.09509 7.00679H6.09517C6.09509 6.94577 6.11993 6.88741 6.16384 6.84515C6.20782 6.80288 6.26712 6.78038 6.32806 6.7828H6.7761C6.89977 6.7828 7.00008 6.88304 7.00008 7.00678C7.00008 7.13053 6.89976 7.23076 6.7761 7.23076H6.32806C6.2079 7.226 6.11298 7.12709 6.11306 7.00678L6.09509 7.00679ZM5.64713 5.66281C5.64721 5.78312 5.55228 5.88195 5.43213 5.88679H4.98409C4.86042 5.88679 4.76011 5.78648 4.76011 5.66281C4.76011 5.53906 4.86042 5.43883 4.98409 5.43883H5.43213C5.55228 5.44359 5.64721 5.5425 5.64713 5.66281ZM6.09509 5.66281H6.09517C6.09509 5.60179 6.11993 5.54343 6.16384 5.50117C6.20782 5.4589 6.26712 5.43633 6.32806 5.43882H6.7761C6.89977 5.43882 7.00008 5.53906 7.00008 5.6628C7.00008 5.78648 6.89976 5.88678 6.7761 5.88678H6.32806C6.2079 5.88194 6.11298 5.78311 6.11306 5.6628L6.09509 5.66281ZM5.64713 4.31883C5.64721 4.43906 5.55228 4.53797 5.43213 4.54281H4.98409C4.86042 4.54281 4.76011 4.4425 4.76011 4.31883C4.76011 4.19508 4.86042 4.09477 4.98409 4.09477H5.43213C5.55228 4.09961 5.64721 4.19852 5.64713 4.31883ZM6.09509 4.31883H6.09517C6.09509 4.25781 6.11993 4.19945 6.16384 4.15719C6.20782 4.11484 6.26712 4.09234 6.32806 4.09477H6.7761C6.89977 4.09477 7.00008 4.19508 7.00008 4.31883C7.00008 4.4425 6.89976 4.54281 6.7761 4.54281H6.32806C6.2079 4.53796 6.11298 4.43906 6.11306 4.31883L6.09509 4.31883ZM9.44609 9.69483L9.44617 9.69475C9.44617 9.7542 9.42257 9.81116 9.38054 9.85319C9.33851 9.89522 9.28156 9.91881 9.22218 9.91881H8.77414C8.65047 9.91881 8.55016 9.8185 8.55016 9.69475C8.55016 9.57108 8.65048 9.47077 8.77414 9.47077H9.22218C9.28234 9.46585 9.34195 9.48546 9.38749 9.52507C9.43304 9.56468 9.46062 9.62108 9.46406 9.68132L9.44609 9.69483ZM8.55007 8.35085L8.55015 8.35077C8.55257 8.22804 8.65147 8.12921 8.77413 8.12679H9.22217C9.34482 8.12921 9.44373 8.22804 9.44615 8.35077C9.44615 8.41022 9.42255 8.46718 9.38052 8.50921C9.33849 8.55116 9.28154 8.57476 9.22216 8.57476H8.77412C8.65397 8.56522 8.56288 8.46225 8.56802 8.34185L8.55007 8.35085ZM8.55007 7.00687L8.55015 7.00679C8.55015 6.88304 8.65046 6.78281 8.77413 6.78281H9.22217C9.34584 6.78281 9.44615 6.88305 9.44615 7.00679C9.44615 7.13054 9.34583 7.23077 9.22217 7.23077H8.77413C8.65749 7.2214 8.56773 7.12382 8.56803 7.00679L8.55007 7.00687ZM8.55007 5.66289L8.55015 5.66281C8.55015 5.53906 8.65046 5.43883 8.77413 5.43883H9.22217C9.28154 5.43883 9.33849 5.46242 9.38053 5.50438C9.42256 5.54641 9.44615 5.60336 9.44615 5.66281C9.44373 5.78555 9.34482 5.88437 9.22217 5.88679H8.77413C8.66179 5.87586 8.57421 5.78453 8.56803 5.67171L8.55007 5.66289Z"
                            fill="#747678"
                          />
                        </svg>
                        <span> {itemtoShow.company.name}</span>
                      </InlineStyled>
                    )}
                  </div>
                </div>
                <hr className="m-0 p-0 bg-cdcdcd border-color-cdcdcd" />
                <div className="d-flex flex-stack px-6 py-2 h-40px">
                  <div className={`d-flex gap-3 ${itemtoShow.expectedCloseDate ? "w-100-115px" : "w-100"}`}>
                    {itemtoShow.tags
                      ? itemtoShow.tags.map((tag, index) =>
                        tag ? (
                          <InlineStyled
                            title={tag.name}
                            key={index}
                            styles={{ backgroundColor: tag.colorCode, customWidth: "calc(100% - 80px)" }}
                            className="text-333 badge badge-dark mb-1 custom-ellipsis  tag-ellipsis rounded-pill m-0 font-size-12px"
                          >
                            {tag.name}
                            <br />
                          </InlineStyled>
                        ) : (
                          ""
                        ),
                      )
                      : null}
                    <InlineStyled title={`${itemtoShow.dealCurrency} ${itemtoShow.dealValue}`} className="custom-ellipsis w-80px-mn fw-500 font-size-13px p-2px text-747678" styles={{ customWidth: "80px" }}>
                      {itemtoShow.dealCurrency} {itemtoShow.dealValue}
                    </InlineStyled>
                  </div>
                  <div>
                    {itemtoShow.expectedCloseDate ? (
                      <div className="p-2px d-flex gap-2 align-items-center fw-500 font-size-13px text-747678">
                        <i className="bi bi-clock"></i> {moment(itemtoShow.expectedCloseDate).format("MMM Do YY")}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </ItemContainer>
          )}
        </Draggable>
      ))
      : null;
  }
}

class InnerItemList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAddDealModal: false,
    };
  }

  onAddDealModalClose = () => {
    this.setState({ openAddDealModal: false });
  };

  onAddDealModalSave = (data) => {
    this.props.onAddDealModalSave(data);
    this.setState({ openAddDealModal: false });
  };

  onAddDealClick = () => {
    this.setState({
      openAddDealModal: true,
    });
  };

  render() {
    const { stageId, items, stageName, pipelineswithstages, selectedPipeline, selectedPipelineId, ownerId } = this.props;
    return (
      <div className="h-100">
        <div className="scroll hover-scroll m-0 max-height-calc-100-percent-minus-38px-plus-38px">
          {items &&
            items.map((item, index) => (
              <DraggableContainer
                key={stageId}
                stageId={stageId}
                stageName={stageName}
                item={item}
                index={index}
                openComposer={this.props.openComposer}
                openScheduleActivity={this.props.openScheduleActivity}
                activityLostReasons={this.props.activityLostReasons}
                callActivityMADoneApi={this.props.callActivityMADoneApi}
                lostReasonStatus={this.props.lostReasonStatus}
                selectedPipelineId={selectedPipelineId}
                history={this.props.history}
              />
            ))}
          <InlineStyled
            className="text-black add-deal-footer fw-600 font-size-16px"
            styles={{
              fontFamily: "Poppins,Helvetica,sans-serif",
            }}
          >
            <StageFooter onClick={() => this.onAddDealClick()}>
              <AddNew>
                <AddIcon />
                Add Deal
              </AddNew>
            </StageFooter>
          </InlineStyled>
        </div>
        <AddDealModal
          dealModalProps={{
            openAddDealModal: this.state.openAddDealModal,
            onAddDealModalClose: () => this.onAddDealModalClose(),
            onAddDealModalSave: (data) => this.onAddDealModalSave(data),
            selectedCurrentState: stageId,
            pipelineswithstages: pipelineswithstages,
            selectedPipeline: selectedPipeline,
            selectedPipelineId: selectedPipelineId,
            pipelinedropdownOptions: this.props.pipelinedropdownOptions,
            // onAddDealName:(e)=> this.onAddDealName(e),
            // onAddOrganization:(e)=> this.onAddOrganization(e),
            // onAddDealValue:(e) => this.onAddDealValue(e),
            // onDealPipelineselect:(e) => this.onDealPipelineselect(e),
            // onExpectedCloseDateSelect:(e) => this.onExpectedCloseDateSelect(e),
            stageId: stageId,
            tags: this.props.tags,
            ownerId: ownerId,
          }}
        />
      </div>
    );
  }
}

class InnerList extends React.Component {
  render() {
    const { stageId, items, provided, stageName, pipelineswithstages, selectedPipeline, selectedPipelineId } = this.props;
    return (
      <DropZone ref={provided.innerRef}>
        <InnerItemList
          stageId={stageId}
          stageName={stageName}
          items={items}
          openComposer={this.props.openComposer}
          openScheduleActivity={this.props.openScheduleActivity}
          pipelineswithstages={pipelineswithstages}
          selectedPipeline={selectedPipeline}
          selectedPipelineId={selectedPipelineId}
          onAddDealModalSave={this.props.onAddDealModalSave}
          activityLostReasons={this.props.activityLostReasons}
          callActivityMADoneApi={this.props.callActivityMADoneApi}
          tags={this.props.tags}
          ownerId={this.props.ownerId}
          pipelinedropdownOptions={this.props.pipelinedropdownOptions}
          lostReasonStatus={this.props.lostReasonStatus}
          history={this.props.history}
        />
      </DropZone>
    );
  }
}

class ItemList extends React.Component {
  render() {
    const { listId, stageId, items, stageName, pipelineswithstages, selectedPipeline, selectedPipelineId } = this.props;
    return (
      <Droppable droppableId={listId}>
        {(provided, dropSnapshot) => (
          <Wrapper isDraggingOver={dropSnapshot.isDraggingOver} ref={provided.innerRef} {...provided.droppableProps}>
            <InnerList
              stageId={stageId}
              items={items}
              provided={provided}
              openComposer={this.props.openComposer}
              openScheduleActivity={this.props.openScheduleActivity}
              pipelineswithstages={pipelineswithstages}
              selectedPipeline={selectedPipeline}
              stageName={stageName}
              selectedPipelineId={selectedPipelineId}
              onAddDealModalSave={this.props.onAddDealModalSave}
              activityLostReasons={this.props.activityLostReasons}
              callActivityMADoneApi={this.props.callActivityMADoneApi}
              tags={this.props.tags}
              ownerId={this.props.ownerId}
              pipelinedropdownOptions={this.props.pipelinedropdownOptions}
              lostReasonStatus={this.props.lostReasonStatus}
              history={this.props.history}
            />
            {provided.placeholder}
          </Wrapper>
        )}
      </Droppable>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    tags: state.DealPipeline.dealTags.list,
  };
};

export default connect(mapStateToProps, null)(ItemList);
